export interface QuickAction {
  label: string
  icon: 'calendar' | 'book' | 'card' | 'bus' | 'utensils' | 'help'
}

export const quickActions: QuickAction[] = [
  { label: 'Timetable', icon: 'calendar' },
  { label: 'Courses', icon: 'book' },
  { label: 'Student ID', icon: 'card' },
  { label: 'Shuttle', icon: 'bus' },
  { label: 'Dining', icon: 'utensils' },
  { label: 'Services', icon: 'help' },
]

export interface ScheduleItem {
  time: string
  code: string
  name: string
  room: string
  state: 'now' | 'next' | 'later'
}

export const todaySchedule: ScheduleItem[] = [
  { time: '10:30', code: 'PHIL 101', name: 'Intro to Philosophy', room: 'B2.14', state: 'now' },
  { time: '13:00', code: 'ECON 101', name: 'Microeconomics', room: 'A1.07', state: 'next' },
  { time: '16:00', code: 'VINU 101', name: 'Leadership Lab', room: 'Hub 3', state: 'later' },
]

export const campusNews = [
  {
    title: 'Registration for Semester 2 opens Monday',
    tag: 'Academics',
    image: 'https://cdn.magicpatterns.com/uploads/tPNgb95D9vYkUp6hFQwWqw/images.jpg',
  },
  {
    title: 'Library extends Level 2 hours to midnight',
    tag: 'Campus Life',
    image: 'https://cdn.magicpatterns.com/uploads/oNchewKvVvyvTvJm3YiWf3/images_(3).jpg',
  },
]

export const LEXCE_AVATAR =
  'https://cdn.magicpatterns.com/patterns/generated-images/5521aaf4-7c8c-44bc-a8cc-55b529be357f.jpg'

export const VINUNI_LOGO_HORIZONTAL =
  'https://cdn.magicpatterns.com/uploads/kbPJU38cD8pyFrH9XS6rtv/VINUNI_Logo_horizontal_(PNG).png'
